export default {
  namespaced: true,
  state: {
    key: 'InvoicesModule',
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
};
